import { useCallback, useState } from 'react'

import { getAction } from '@/apis/config'
import { API_LIMIT } from '@/constants/api'
import useQueryPage from '@/hooks/useQueryPage'
import { GetActionResponse } from '@/types/apis/config'

export const useActionAdmin = () => {
  const currentPage = useQueryPage()
  const [page, setPage] = useState(currentPage)

  const [actionAdminResponse, setActionAdminResponse] = useState<GetActionResponse>()
  const [loading, setLoading] = useState(false)

  const get = useCallback(async () => {
    try {
      setLoading(true)
      const res = await getAction({ page, limit: API_LIMIT })
      setActionAdminResponse(res)
    } finally {
      setLoading(false)
    }
  }, [page])

  return {
    loading,
    getAction: get,
    actionAdminResponse,
    page,
    pageSize: API_LIMIT,
    setPage,
  }
}
